// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","introParagraph":"page_introParagraph__LJPUx","graphsSection":"page_graphsSection__E4nCR"};